import * as React from "react";
function SvgEdit(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 13v-1.172l6-6L18.172 7l-6 6H11zm-2-2l6.586-6.586L17 3l1.414 1.414 1.172 1.172L21 7l-1.414 1.414L13 15H9v-4zM5 5a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-6h-2v6H5V7h6V5H5z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgEdit);
export default ForwardRef;
